import React,{useContext} from 'react';
import { Layout, Menu, Typography } from 'antd';
import {
  DashboardOutlined,
  SettingOutlined,
  DatabaseOutlined,
  FileTextOutlined,
} from '@ant-design/icons';
import { Link, useLocation } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
const { Sider } = Layout;
const { Title } = Typography;

const AdminSidebar = ({ collapsed, setCollapsed }) => {
  const location = useLocation();
const { user } = useContext(AuthContext);
 const isSuperAdmin = user?.id === 1; // 👈 ONLY THIS USER
const isMarketing = user?.role === 'marketing'; // 👈 ONLY THIS USER
const isAdmin = user?.role === 'admin'; // 👈 ONLY THIS USER
  const getOpenKeys = () => {
    const currentPath = location.pathname;
    if (currentPath.startsWith('/admin/settings')) return ['settings'];
    if (currentPath.startsWith('/admin/inventory')) return ['inventory'];
    if (currentPath.startsWith('/admin/reports')) return ['reports'];
    return [];
  };

  return (
    <Sider
      collapsible
      collapsed={collapsed}
      onCollapse={(value) => setCollapsed(value)}
      width={250}
      breakpoint="lg"
      collapsedWidth="0"
      style={{ minHeight: '100vh' }}
    >
      <div style={{ textAlign: 'center', padding: '16px' }}>
        <Title level={4} style={{ color: 'white', margin: 0 }}>
          JS-Admin
        </Title>
      </div>

      <Menu
        theme="dark"
        mode="inline"
        defaultOpenKeys={getOpenKeys()}
        selectedKeys={[location.pathname]}
      >
        <Menu.Item key="/admin/dashboard" icon={<DashboardOutlined />}>
          <Link to="/admin/dashboard">Dashboard</Link>
        </Menu.Item>
  {!isMarketing && (
        <Menu.SubMenu key="settings" icon={<SettingOutlined />} title="Settings">
          <Menu.Item key="/admin/create-user">
            <Link to="/admin/create-user">Create User</Link>
          </Menu.Item>
          <Menu.Item key="/admin/create-shop">
            <Link to="/admin/create-shop">Create Shop</Link>
          </Menu.Item>
          <Menu.Item key="/admin/create-warehouse">
            <Link to="/admin/create-warehouse">Create Warehouse</Link>
          </Menu.Item>
              <Menu.Item key="/admin/create-bankaccount">
            <Link to="/admin/create-bankaccount">Create Bank Account</Link>
          </Menu.Item>
        </Menu.SubMenu>
  )}
 
                 <Menu.SubMenu key="sparepart" icon={<DatabaseOutlined />} title="Sparepart Management">
                    {!isMarketing && (
                     <Menu.Item key="/admin/add-sparepart">
            <Link to="/admin/add-sparepart">Add Sparepart</Link>
          </Menu.Item>
              )}
        
          <Menu.Item key="sparepart-control">
            <Link to="/admin/sparepart-control">Sparepart Control</Link>
          </Menu.Item>
          <Menu.Item key="/admin/sparepart-audit">
            <Link to="/admin/sparepart-audit">Sparepart Audit</Link>
          </Menu.Item>
            
        </Menu.SubMenu>
    
      
           <Menu.SubMenu key="credit" icon={<DatabaseOutlined />} title="Credit Management">
                    <Menu.Item key="/admin/show-credit">
            <Link to="/admin/show-credit">Credit Sales</Link>
          </Menu.Item>
          
         
        
        </Menu.SubMenu>
        
        {!isMarketing && (
        <Menu.SubMenu key="inventory" icon={<DatabaseOutlined />} title="Inventory">
           <Menu.Item key="addinventory">
            <Link to="/admin/addtoinventory">Add Inventory</Link>
          </Menu.Item>
          <Menu.Item key="inventorylist">
            <Link to="/admin/inventorylist">Inventory List</Link>
          </Menu.Item>
          <Menu.Item key="/admin/inventory/log">
            <Link to="/admin/log">Inventory Log</Link>
          </Menu.Item>
      
        
        </Menu.SubMenu>
     
        )}
           <Menu.SubMenu key="sale" icon={<DatabaseOutlined />} title="Sales">
         
          <Menu.Item key="/admin/sales-list">
            <Link to="/admin/sales-list">Sales List</Link>
          </Menu.Item>
        
        </Menu.SubMenu>
         {!isMarketing && (
          <Menu.SubMenu key="purchase" icon={<DatabaseOutlined />} title="Purchase">
            <Menu.Item key="/admin/purchase-order">
              <Link to="/admin/purchase-order">All Purchase Orders</Link>
            </Menu.Item>
            <Menu.Item key="/admin/purchase-order/create">
              <Link to="/admin/purchase-order/create">Create New PO</Link>
            </Menu.Item>
            <Menu.Item key="/admin/purchase-order/bulk-create">
              <Link to="/admin/purchase-order/bulk-create">Bulk Create PO</Link>
            </Menu.Item>
            <Menu.Item key="/admin/low-stock">
              <Link to="/admin/low-stock">Low Stock</Link>
            </Menu.Item>
          </Menu.SubMenu>
          )}
        
               {(isMarketing || isSuperAdmin || isAdmin) && (
          <Menu.SubMenu key="notification" icon={<DatabaseOutlined />} title="Notification">
         
           <Menu.Item key="/admin/customer-notification">
             <Link to="/admin/customer-notification">Send Notification</Link>
           </Menu.Item>
           <Menu.Item key="/admin/customer-management">
             <Link to="/admin/customer-management">Customer Management</Link>
           </Menu.Item>
        
        </Menu.SubMenu>
           )}
              {isSuperAdmin && (
          <Menu.SubMenu key="reports" icon={<FileTextOutlined />} title="Reports">
            <Menu.Item key="/admin/sales-report">
              <Link to="/admin/sales-report">Sales Reports</Link>
            </Menu.Item>
            <Menu.Item key="/admin/inventory-report">
              <Link to="/admin/inventory-report">Inventory Reports</Link>
            </Menu.Item>
            <Menu.Item key="/admin/customer-report">
              <Link to="/admin/customer-report">Customer Reports</Link>
            </Menu.Item>
             <Menu.Item key="credit-report">
            <Link to="/admin/credit-report">Credit Report</Link>
          </Menu.Item>
          </Menu.SubMenu>
        )}
      </Menu>
    </Sider>
  );
};

export default AdminSidebar;
